import React from 'react'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

import srgcomplexdroneshoot from "../images/srg complex drone shoot.jpg";
import garden from "../images/GARDEN photo.jpg";
import interior from "../images/Interior Villa.jpg";
import interiorvilla from "../images/3bhk villa photo interor.jpg";

import maingateproject from "../images/main gate srg.jpg";
import waterdesign  from "../images/Water Design.jpg";
import villa_krishnagar from "../images/villa krishnagar.jpg";
import gardenview from "../images/garden view.jpg";


import bhk4krishnagar from "../images/4bhk new photo.jpg"
import bhk4villaluxury from "../images/4BHK villa plot complete.jpg";
import luxuryvillaplots from "../images/4BHK plot.jpg";
import villasaleready from "../images/READY VILLA SALE.jpg"

function Gallery() {
  return (
    <div>
        
         <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={srgcomplexdroneshoot} className="card-img-top" alt="best 3bhkvillakrishnagar" />

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">SRG COMPLEX </h5>
                                                <p className="card-text">Our Project</p>
                                          

                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={garden} className="card-img-top" alt="garden"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">SRG COMPLEX </h5>
                                                <p className="card-text">Garden</p>
                                                
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={villa_krishnagar} className="card-img-top" alt="villa_krishnagar"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">SRG COMPLEX </h5>
                                                <p className="card-text">Villa Interior</p>
                                             
                                              
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={gardenview} className="card-img-top" alt="gardenview"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >SRG COMPLEX                               </h5>
                                                <p className="card-text">Villa Interior</p>
                                              
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
              <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={maingateproject} className="card-img-top" alt="best 3bhkvillakrishnagar" />

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">SRG COMPLEX </h5>
                                                <p className="card-text">Main Gate</p>
                                          

                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={waterdesign} className="card-img-top" alt="garden"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">SRG COMPLEX </h5>
                                                <p className="card-text">Foura Water </p>
                                                
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                  
  <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={interior} className="card-img-top" alt="interior" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">SRG COMPLEX </h5>
                                                <p className="card-text">Villa Interior</p>
                                             
                                              
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={interiorvilla} className="card-img-top" alt="interiorvilla"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >SRG COMPLEX                               </h5>
                                                <p className="card-text">Villa Interior</p>
                                              
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


             <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={bhk4villaluxury} className="card-img-top" alt="bhk4villaluxury"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">SRG COMPLEX </h5>
                                                <p className="card-text">4BHK Villa</p>
                                          

                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={luxuryvillaplots} className="card-img-top" alt="luxuryvillaplots"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">SRG COMPLEX </h5>
                                                <p className="card-text">4BHK Villa </p>
                                                
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                  
  <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={bhk4krishnagar} className="card-img-top" alt="bhk4krishnagar" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">SRG COMPLEX </h5>
                                                <p className="card-text">Villa Interior</p>
                                             
                                              
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={villasaleready} className="card-img-top" alt="villasaleready"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >SRG COMPLEX                               </h5>
                                                <p className="card-text">4BHK Villa </p>
                                              
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
  )
}

export default Gallery